import type { ButtonHTMLAttributes } from "react";

import { cn } from "@/lib/utils/cn";

type ButtonVariant = "primary" | "secondary" | "ghost";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
};

const variants: Record<ButtonVariant, string> = {
  primary: "bg-primary text-primary-foreground hover:bg-primary/90 active:bg-primary/80",
  secondary: "border border-border bg-background text-foreground hover:bg-muted active:bg-muted/70",
  ghost: "text-foreground hover:bg-muted active:bg-muted/70",
};

export function Button({ className, variant = "primary", ...props }: ButtonProps) {
  return (
    <button
      data-ui="button"
      className={cn(
        "inline-flex h-9 max-w-full items-center justify-center gap-2 rounded-md px-3 text-sm font-medium leading-5 transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:pointer-events-none disabled:opacity-50 [&>svg]:shrink-0",
        variants[variant],
        className,
      )}
      {...props}
    />
  );
}
